/**
 * Cau noi giua kho trang thai va React.
 *
 * useSyncExternalStore la API dung cho viec nay trong React 18/19: no xu ly
 * dung "tearing" khi render dut quang. Anh chup phai co tham chieu ON DINH giua
 * hai lan cap nhat that su - AppStore dam bao dieu do bang cach thay ca doi
 * tuong trang thai moi lan set().
 */
import { useSyncExternalStore } from 'react';
import { store, type AppState } from './store';

export function useAppState(): AppState {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}

export {
  store,
  AppStore,
  ZOOM_STEPS,
  SHAPE_TOOLS,
  isShapeTool,
  sortAnnotationsByZ,
  nextZAbove,
} from './store';
export type {
  AppState,
  DocStatus,
  ToolId,
  ShapeTool,
  HistoryEntry,
  InspectorTab,
} from './store';
export { describe, invert, coalesce, COALESCE_WINDOW_MS } from './commands';
